import { Box } from "@mui/material";
import { red } from "@mui/material/colors";
import { BarChart } from "@mui/x-charts/BarChart";
import { useEffect, useState } from "react";

const AssignedJobsByUser = ({ labRequestTests }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (labRequestTests && labRequestTests.length > 0) {
      const processedData = processChartData(labRequestTests);
      setChartData(processedData);
    } else {
      setChartData(null);
    }
  }, [labRequestTests]);

  const processChartData = (apiData) => {
    const users = [];
    const totalJobs = [];
    const finalized = [];
    const pending = [];

    apiData.forEach((row) => {
      // Ensure we handle the data properly
      const userName = String(row[0] || "Unknown");
      const total = Number(row[1]) || 0;
      const final = Number(row[2]) || 0;
      const pend = Number(row[3]) || 0;

      users.push(userName);
      totalJobs.push(total);
      finalized.push(final);
      pending.push(pend);
    });

    return {
      users,
      series: [
        {
          label: "Pending",
          data: pending,
          color: "#fc7373ff",
        },
        {
          label: "Approved",
          data: finalized,
          color: "#4caf50",
        },
        {
          label: "Total",
          data: totalJobs,
          color: "#8b83ffff",
        },
      ],
    };
  };

  return (
    <Box sx={{ width: "100%", height: 400 }}>
      {chartData ? (
        <BarChart
          dataset={chartData.users.map((user, index) => ({
            user,
            total: chartData.series[2].data[index],
            approved: chartData.series[1].data[index],
            pending: chartData.series[0].data[index],
          }))}
          xAxis={[
            {
              dataKey: "user",
              scaleType: "band",
              label: "TO / ATO",
            },
          ]}
          yAxis={[
            {
              label: "",
              labelStyle: {
                angle: -90,
                textAnchor: "middle",
                dominantBaseline: "auto",
                x: "-50px",
                // Add margin/padding if needed
                marginRight: "20px",
              },
            },
          ]}
          series={[
            {
              dataKey: "pending",
              label: "Pending",
              color: "#fc7373ff",
            },
            {
              dataKey: "approved",
              label: "Approved",
              color: "#4caf50",
            },
            {
              dataKey: "total",
              label: "Total",
              color: "#8b83ffff",
            },
          ]}
          height={350}
          barLabel="value"
          margin={{ top: 80, bottom: 60, left: 60, right: 20 }}
          slotProps={{
            legend: {
              direction: "row",
              position: { vertical: "top", horizontal: "middle" },
            },
          }}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            color: "text.secondary",
            fontStyle: "italic",
          }}
        >
          Loading or no data available...
        </Box>
      )}
    </Box>
  );
};

export default AssignedJobsByUser;
